'use client';

import { Fragment, useEffect, useState } from 'react';

import Header from 'components/Layout/Common/Header';
import { getAuthIdentity } from 'services/identity.service';

const WelcomePage = () => {
  const [planner, setPlanner] = useState(null);
  useEffect(() => {
    setPlanner(getAuthIdentity());
  }, []);

  const welcomeMessage = `Welcome ${planner?.name || ''}`;
  return (
    <Fragment>
      <div className='page-content'>
        <div className='text-center'>
          <p>{welcomeMessage}</p>
        </div>
        <Header title='Home'></Header>
      </div>
    </Fragment>
  );
};

export default WelcomePage;
